import { defineComponent as _defineComponent } from 'vue'
import { computed, ComputedRef, watch } from 'vue';

import pinia from '@/stores';
import { useStaticResourcesStore } from '@/stores/StaticResources';

interface Props {
  name: string;
  title?: string;
  showFocus?: boolean;
  showFullColourFocus?: boolean;
  focused?: boolean;
  /**
   * For situations that require icon usage at small sizes,
   * optionally set the following 'heavy' property to true to give the icon a bolder/thicker appearance
   */
  heavy?: boolean;
  fade?: boolean;
  fillColour?: string | null;
  includeViewBox?: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'BrandIcon',
  props: {
    name: null,
    title: null,
    showFocus: { type: Boolean, default: true },
    showFullColourFocus: { type: Boolean, default: false },
    focused: { type: Boolean, default: false },
    heavy: { type: Boolean, default: false },
    fade: { type: Boolean, default: false },
    fillColour: { default: null },
    includeViewBox: { type: Boolean, default: true }
  },
  setup(__props: any) {

const props = __props as { name: string, title?: string, showFocus: boolean, showFullColourFocus: boolean, focused: boolean, heavy: boolean, fade: boolean, fillColour: string | null, includeViewBox: boolean }

const staticResourcesStore = useStaticResourcesStore(pinia);



const isPublicIcon: ComputedRef<boolean> = computed(() => {
  return props.name.startsWith('/public/');
});

const isFlatIcon: ComputedRef<boolean> = computed(() => {
  return props.name.startsWith('flat/');
});

const isFullColour: ComputedRef<boolean> = computed(() => {
  return props.name.includes('fullColour/');
});

const imageId: ComputedRef<string> = computed(() => {
  return props.name.replace(/.*\//, '');
});

const baseImage: ComputedRef<string> = computed(() => {
  return staticResourcesStore.resolvedPaths[`${props.name}.svg`];
});

const focusImageName: ComputedRef<string | undefined> = computed(() => {
  if (!props.name) {
    return;
  }
  if (isFlatIcon.value || isPublicIcon.value || (isFullColour.value && !props.showFullColourFocus)) {
    return;
  }
  if (!props.showFocus) {
    return;
  }
  return `${props.name}-focus.svg`;
});

const focusImage: ComputedRef<string | undefined> = computed(() => {
  if (!focusImageName.value) {
    return;
  }
  return staticResourcesStore.resolvedPaths[focusImageName.value];
});

const propStyles: ComputedRef<Record<string, string>> = computed(() => {
  let styleObject = {};
  if (props.fillColour) {
    styleObject = {
      fill: props.fillColour,
    };
  }
  return styleObject;
});

async function resolveImagePath(name: string): Promise<string> {
  let resolved: string = staticResourcesStore.resolvedPaths[name];
  if (!resolved) {
    if (isPublicIcon.value) {
      resolved = name.substring(7);
    } else {
      resolved = await require(`@/assets/images/svg/icon/${name}`);
    }
    staticResourcesStore.setResolvedPath(name, resolved);
  }
  return resolved;
}

watch(() => props.name, (newValue: string) => {
  if (!newValue) {
    return;
  }
  const toResolve: string = `${newValue}.svg`;
  if (isPublicIcon.value) {
    staticResourcesStore.setResolvedPath(toResolve, toResolve.substring(7));
  } else {
    resolveImagePath(toResolve);
  }
}, { immediate: true });

watch(() => focusImageName.value, (newValue?: string) => {
  if (!newValue) {
    return;
  }
  resolveImagePath(newValue);
}, { immediate: true });

return { __sfc: true,staticResourcesStore, props, isPublicIcon, isFlatIcon, isFullColour, imageId, baseImage, focusImageName, focusImage, propStyles, resolveImagePath }
}

})